import { render, staticRenderFns } from "./AdminSubscription.vue?vue&type=template&id=54f41be4&scoped=true"
import script from "./AdminSubscription.vue?vue&type=script&lang=js"
export * from "./AdminSubscription.vue?vue&type=script&lang=js"
import style0 from "./AdminSubscription.vue?vue&type=style&index=0&id=54f41be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f41be4",
  null
  
)

export default component.exports